import {
  CONTENT_FULFILLED,
  MENU_TOGGLED,
  MENU_ACTIVATED,
  MENU_DEACTIVATED,
} from '../actions';
import mergeSliceState from '../helpers/mergeSliceState';
import get from '../helpers/get';

const initialState = {};

const initializeMenus = (prevState, content) => ({
  ...(content.body || []).reduce((nextMenus, sliceContent) => {
    if (sliceContent.menu) {
      return {
        ...nextMenus,
        [sliceContent.sliceId]: { activeMenuIndex: -1 },
      };
    }
    return nextMenus;
  }, prevState),
});

const toggleMenu = (prevState, sliceId, menuIndex) => mergeSliceState(prevState, sliceId, {
  activeMenuIndex: (get(prevState, [sliceId, 'activeMenuIndex']) === menuIndex) ? -1 : menuIndex,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case CONTENT_FULFILLED:
      return initializeMenus(state, action.payload);
    case MENU_TOGGLED:
      return toggleMenu(state, action.payload.sliceId, action.payload.menuIndex);
    case MENU_ACTIVATED:
      return mergeSliceState(state, action.payload.sliceId, {
        activeMenuIndex: action.payload.menuIndex,
      });
    case MENU_DEACTIVATED:
      if (get(state, [action.payload.sliceId, 'activeMenuIndex']) === action.payload.menuIndex) {
        return mergeSliceState(state, action.payload.sliceId, {
          activeMenuIndex: -1,
        });
      }
      return state;
    default:
      return state;
  }
};
